import { payrollPromo } from '~/content/payroll';
import { cn } from '~/lib/cn';

/** Offer strip under the payroll hero; "Learn more" opens the offer dialog (Figma 1269:46795). */
export function PayrollPromoBanner({
  onLearnMore,
  className,
}: {
  onLearnMore: () => void;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'flex items-center gap-6 border-y border-grey-100 py-6 md:gap-[23px] md:py-5 md:ps-5',
        className,
      )}>
      <img src={payrollPromo.icon} alt="" aria-hidden="true" className="size-6 shrink-0" />
      <p className="flex-1 text-[12px] leading-[1.32] tracking-[-0.024px] text-grey-900 md:text-body md:text-black">
        {payrollPromo.text}{' '}
        {/* On mobile the link runs inline with the copy; on desktop it sits at the far end. */}
        <button
          type="button"
          aria-haspopup="dialog"
          onClick={onLearnMore}
          className="cursor-pointer text-red-500 hover:text-red-700 md:hidden">
          {payrollPromo.learnMoreLabel}.
        </button>
      </p>
      <button
        type="button"
        aria-haspopup="dialog"
        onClick={onLearnMore}
        className="hidden shrink-0 cursor-pointer text-body text-red-500 hover:text-red-700 md:block">
        {payrollPromo.learnMoreLabel}
      </button>
    </div>
  );
}
